// Use CRA proxy in development (proxies /api/* to backend via package.json proxy config)
// In production, use REACT_APP_API_BASE_URL environment variable
const BASE_URL = 
  process.env.REACT_APP_API_BASE_URL && process.env.REACT_APP_API_BASE_URL.trim() !== ''
    ? process.env.REACT_APP_API_BASE_URL
    : '/api'; // Relative path - CRA dev server proxies to backend (port 5001)

export { BASE_URL };